import React from "react";
import Modal from '../Modal'
import LoaderButton from "../LoaderButton";
import { translate } from "../../utils/useful";
import FormViewer from "../FormViewer";
import SwitchInput from "../inputs/SwitchInput";
import TopicView from "../views/messenger/sideBar/TopicView";
import StagesManager from "../StagesManager";
import ImportModalFirst from "./ImportModalFirst";
import ImportModalSecond from "./ImportModalSecond";
import ImportModalThird from "./ImportModalThird";
import ImportModalForth from "./ImportModalForth";
import Collapsible from "react-collapsible";


class BatchConfirm extends React.Component {
    state = {
        headers: [
            { key: 'table', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'Table 1', value: 'Equal' }, { title: 'Table 2', value: 'Equal' }], label: '{{lang}}Table', placeholder: 'Pick a table...', required: false } },
            { key: 'layout', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }], label: '{{lang}}View', placeholder: '{{lang}}Pick a view...', required: false } },
            // { key: 'fieldsizing', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Feild sizing', placeholder: '{{lang}}Actual size', required: true } },
            // { key: 'fontsize', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Font size', placeholder: '{{lang}}Normal', required: true } },
        ],

        headers2: [
            { key: 'field', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'Name', value: 'Equal' }, { title: 'Assignee', value: 'Equal' }, { title: 'Notes', value: 'Equal' }, { title: 'Status', value: 'Equal' }], label: '{{lang}}Feild', placeholder: 'Pick a field to update...', required: false } },
            { key: 'action', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'Clear cell contents', value: 'Equal' }, { title: 'Set cell value', value: 'Equal' }, { title: 'set cell value randomly', value: 'Equal' }], label: '{{lang}}Action', placeholder: '{{lang}}Pick an action', required: false } },
            { key: 'value', type: 'TextInput', col: '12', information: { label: '{{lang}}New Value', placeholder: '{{lang}}Select...', required: true } },
            // { key: 'fontsize', type: 'SelectInput', col: '6', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Font size', placeholder: '{{lang}}Normal', required: true } },
        ],

        showMore: []

    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }


    render() {
        let options = this.state.options
        return (


            <div className="">
                <div className="p-3 flexcb" style={{ backgroundColor: "#fff", borderBottom: "1px solid #eee" }}>
                    <p className="font-size-14 weight-300">Batch Update</p>
                    <button className="blue-btn br-5 px-2 py-1">
                        <p className="white">Confirm</p>
                    </button>
                </div>
                <div className="p-3">
                    <button className="flexcb w-100" onClick={() => this.setState({ showMore: !this.state.showMore })}>
                        <p className="font-size-14" style={{ color: "#0961ed" }}>16 records are about to update</p>
                        <img src="/assets/icons/plus-blue.svg" />
                    </button>
                </div>
                <div className="px-3">
                    <Collapsible open={this.state.showMore}>
                        <div>
                            <p> You will going to see tha updates here</p>
                        </div>
                    </Collapsible>
                </div>
            </div>

        );

    }
}


export default BatchConfirm;
